import React, { useEffect, useState } from "react";
import "./SuggestProducts.css";
import { db } from "../firebase";
import { collection, getDocs, query, where, limit } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

// Normalisation produit
function normalizeProduct(doc) {
  const d = doc.data();
  return {
    id: doc.id,
    title: d?.Name ?? "Untitled",
    category: d?.Categorie?.Label ?? "",
    brand: d?.Brand ?? "",
    image: d?.ImageUrl ?? "",
    price: Number(d?.Stores?.Cassablanca?.SalePrice ?? 0),
    oldPrice: Number(d?.oldPrice ?? 0),
    badge: d?.QuantityAvailable === 0 ? "Out of Stock" : "",
    IsPack: Boolean(d?.HasChilds ?? false),
    ParentId: d?.ParentId ?? null,
    stock: Number(
    Number(d?.Stores?.Cassablanca?.Quantity ?? 0) +
    Number(d?.Stores?.Dekon?.Quantity ?? 0) +
    Number(d?.Stores?.Baguida?.Quantity ?? 0)
  ) - Number(3),
    InShip: Number(d?.QuantityInPo ?? 0) + Number(d?.QuantityInShpping ?? 0),
    Images: d?.Images ?? [],
    Description: d?.Description ?? "Pas de description...",
    SubCategorie: d?.Categorie?.SubCategorie?.Id ?? null,
    MaxiDiscount: Number(d?.MaxiDiscount ?? 0),
    GetDiscount: Boolean(d?.GetDiscount ?? false), 
    ApplyInvitation: Boolean(d?.ApplyInvitation ?? false),
  };
}

export default function SuggestProducts({ idcategorie, title = "Popular Products" }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const navigate = useNavigate();

  // 🔥 Charger depuis Firestore
  useEffect(() => {
    let mounted = true;
    async function fetchProducts() {
      try {
        setLoading(true);
        setErr("");

        const q = query(
          collection(db, "items"),
          where("Categorie.SubCategorie.Id", "==", idcategorie),
          where("IsProductValidated","==", true),
          limit(24) // limite pour pas tout charger
        );

        const snap = await getDocs(q);
        if (!mounted) return;

        const list = snap.docs.map(normalizeProduct);
        setProducts(list);
      } catch (e) {
        console.error(e);
        setErr("Impossible de charger les produits.");
      } finally {
        if (mounted) setLoading(false);
      }
    }

    if (idcategorie) {
      fetchProducts();
    }
    return () => (mounted = false);
  }, [idcategorie]);

  const handleDetails = (item) => navigate(`/details/${item.id}`, { state: { item } });

  if (loading) {
    return <p style={{ textAlign: "center" }}>Chargement…</p>;
  }
  if (err) {
    return <p style={{ textAlign: "center", color: "red" }}>{err}</p>;
  }
  if (!products.length) {
    return <p style={{ textAlign: "center" }}>Aucun produit disponible.</p>;
  }

  return (
    <section className="suggest-wrap-sg">
      <div className="suggest-head-sg">
        <h3 className="suggest-title-sg">{title}</h3>
      </div>

      <div className="suggest-grid-sg">
        {products.map((p) => (
          <article key={p.id} className="card-sg">
            <div className="media-sg">
              {p.badge && <span className={`badge-sg ${formatBadgeClass(p.badge)}`}>{p.badge}</span>}
              <img
                src={p.image || "https://via.placeholder.com/600x600?text=No+image"}
                alt={p.title}
                loading="lazy"
                onClick={() => handleDetails(p)}
              />
            </div>

            <div className="body-sg">
              <p className="category-sg">{p.category}</p>
              <h4 className="title-sg" title={p.title}>{p.title}</h4>
              {p.brand && <p className="brand-sg">By <span>{p.brand}</span></p>}

              <div className="price-row-sg">
                <span className="price-sg">{formatMoney(p.price)}</span>
                {!!p.oldPrice && (
                  <span className="old-sg">{formatMoney(p.oldPrice)}</span>
                )}
              </div>

              
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

function formatMoney(v) {
  const n = Number(v || 0);
  return `${n} FCFA`;
}

function formatBadgeClass(text) {
  const t = String(text).toLowerCase();
  if (t.includes("new")) return "is-new";
  if (t.includes("out")) return "is-out";
  return "is-sale";
}
